module.exports = __webpack_public_path__ + "static/media/model1.e59b1876.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/model1.jpeg
// module id = 45
// module chunks = 0